module.exports = __webpack_public_path__ + "img/analysis_revise_wrong.0eb83846.png";